/* hs-eslint ignored failing-rules */
'use es6';

import { fromJS, Map as ImmutableMap } from 'immutable';
import getLang from 'I18n/utils/getLang';
import ActionTypes from './ActionTypes';
import { shouldFetch } from '../utils/ActionUtils';
import { normalizeLessonResponse } from 'academy-shared-js/utils/NormalizationUtils';
import responseMapper from 'academy-shared-js/utils/responseMapper';
import { getRecommendationsForLesson } from '../features/recommendations';
import { getAllLessons, getAllPartnerLessons, getFullLesson } from '../features/lessons';
export function lessonByIdRequesting(lessonId) {
  return {
    type: ActionTypes.GET_LESSON_BY_ID_REQUESTING,
    meta: lessonId
  };
}
export function lessonByIdReceived(payload, lessonId, requestLanguage) {
  const normalized = normalizeLessonResponse(responseMapper(payload));
  normalized.lesson = normalized.lesson.toMap().set('contentIds', normalized.lesson.get('content')).set('hsSoftwareFilters', payload.hsSoftwareFilters).set('subCategories', payload.subCategories).set('requestLanguage', requestLanguage).remove('content');
  return {
    type: ActionTypes.GET_LESSON_BY_ID_RECEIVE,
    payload: normalized,
    meta: lessonId
  };
}
export function lessonByIdRequestError(error, lessonId) {
  return {
    type: ActionTypes.GET_LESSON_BY_ID_ERROR,
    error: true,
    payload: error,
    meta: lessonId
  };
}
export function getLessonById(lessonId, language) {
  return dispatch => {
    dispatch(lessonByIdRequesting(lessonId));
    getFullLesson(Number(lessonId), language).then(response => dispatch(lessonByIdReceived(response, lessonId, language)), errorResponse => dispatch(lessonByIdRequestError(errorResponse, lessonId))).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export function fetchLessonIfNeeded(lessonId, language) {
  return (dispatch, getState) => {
    const thisLessonState = getState().lessons.getIn(['lessonsById', lessonId]);

    if (shouldFetch(thisLessonState, language)) {
      dispatch(getLessonById(lessonId, language));
    }
  };
}
export function getLessonsRequesting(isPartner = false) {
  return {
    type: ActionTypes.GET_LESSONS_REQUESTING,
    meta: {
      isPartner
    }
  };
}
export function lessonsReceived(response, requestLanguage, isPartner = false) {
  const lessonsById = fromJS(isPartner ? response : response.result).reduce((map, object) => {
    const stringifiedIDs = object.set('id', object.get('id').toString()).set('contentIds', object.get('contentIds').map(contentId => contentId.toString())).set('requestLanguage', requestLanguage);
    return map.set(stringifiedIDs.get('id'), stringifiedIDs);
  }, new ImmutableMap());
  return {
    type: ActionTypes.GET_LESSONS_BY_ID_RECEIVE,
    payload: {
      lessonsById
    },
    meta: {
      totalCount: (isPartner ? response : response.result).length,
      timestamp: response.timestamp,
      isPartner
    }
  };
}
export function searchLessonsRequestError(error) {
  return {
    type: ActionTypes.GET_LESSONS_ERROR,
    error: true,
    payload: error
  };
}
export function fetchPublicLessons(language = getLang()) {
  return dispatch => {
    dispatch(getLessonsRequesting());
    getAllLessons(language).then(result => dispatch(lessonsReceived(result, language))).catch(errorResponse => dispatch(searchLessonsRequestError(errorResponse)));
  };
}
export function fetchPartnerLessons(language = getLang()) {
  return dispatch => {
    dispatch(getLessonsRequesting(true));
    return getAllPartnerLessons(language).then(response => dispatch(lessonsReceived(response, language, true))).catch(err => {
      dispatch(searchLessonsRequestError(err));
      setTimeout(() => {
        throw err;
      });
    });
  };
}
const recommendedLessonsRequesting = {
  type: ActionTypes.GET_RECOMMENDED_LESSONS_REQUESTING
};

const recommendedLessonsRequestError = errorResponse => ({
  type: ActionTypes.GET_RECOMMENDED_LESSONS_ERROR,
  payload: errorResponse,
  error: true
});

const recommendedLessonsReceived = (payload, seedLessonId) => ({
  type: ActionTypes.GET_RECOMMENDED_LESSONS_RECEIVED,
  payload: {
    recommendations: fromJS(payload.recommendations),
    seedLessonId
  }
});

export function getRecommendedLessons(seedLessonId) {
  return dispatch => {
    dispatch(recommendedLessonsRequesting);
    getRecommendationsForLesson(seedLessonId).then(response => dispatch(recommendedLessonsReceived(response, seedLessonId)), error => dispatch(recommendedLessonsRequestError(error))).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}